<template>
  <div class="WapRank">
    <div class="hero">
      <div class="group">
        <div class="bt" :class="{focus: fcg==g.key}" v-for="g in groups" @click="focus(g.key)">{{g.text}}</div>
      </div>
      <div class="list">
        <div class="loading" :class="{show: loading}">
          数据加载中...
        </div>
        <div class="hd">
          <div class="img">排名</div>
          <div>名称</div>
          <div>战力积分</div>
          <div>战区</div>
        </div>
        <rank_list :ranks="heroRanks"></rank_list>
        <!-- <div class="note">去 PC 端查看完整榜单</div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

 import rankList from '@/components/waprank/rankList.vue'
export default {
  name: 'WapRank',
   components: {
     rank_list: rankList
   },
   data () {
     return {
       fcg: 's',
       fcgk: 's',
       heroRanks: [],
       knightRanks: [],
       loading: false
     }
   },
   methods: {
     focus(c, isk=false) {
       this.loading = true
       if(isk)
       {
         this.fcgk = c;
       }
       else
         {
       this.fcg = c;
         }
       this.fetchData(isk);
     },
     fetchData() {
       let group =  this.indexOfGroup[this.fcg];
       let uri = '/api/rank/?group='+group;
       this.$http.get(uri)
           .then(res => {
             this.heroRanks = res.data.map(d=>
               {return {rank:d.rank,
                        name:d.username,
                        score: d.score,
                        area: d.area_name.split(' ')[0]}});
             this.loading = false
           })
     }
   },
   mounted () {
     this.fetchData(false);
     this.fetchData(true);
       },
   computed : {
     indexOfGroup() {
       return  {
         s: 1,
         m: 2,
         l: 3
       }
     },
     groups() {
       return this.$store.state.enroll.groups
     },
   },
}
</script>

<style scoped>
 .WapRank {
   background-color: #112442;
 }
 .hero{
   background-image: url(/oss/images/wap/rank/rank-do-bg.png);
   background-size: 100vw;
   background-repeat: no-repeat;
 }
.knight{
   background-image: url(/oss/images/wap/rank/rank-undo-bg.png);
   background-size: 100vw;
   background-repeat: no-repeat;
 }

 .group{
   padding-top: 35vh;
   display: flex;
   align-items:center;
   justify-content:center;
 }
 .knight .group{
   padding-top: 52vh;
 }
 .group .bt{
   width: 25vw;
   height: 7.35vw;
   font-size: 3vw;
   line-height: 7.35vw;
   background-image: url(/oss/images/wap/rank/button-other.png);
   background-size: 25vw;
   background-repeat: no-repeat;
   background-position: center;
   margin: 1px;
   text-align:center;
 }
 .group .bt.focus{
   background-image: url(/oss/images/wap/rank/button-light.png);
   color: rgba(240,240, 240, 0.8);
 }
 .list{
   position: relative;
   display: flex;
   flex-direction: column;
   align-items:center;
 }
 .list .hd{
   width: 90vw;
   display: flex;
   height: 40px;
   font-size: 14px;
   align-items:center;
   justify-content:space-around;
   color: rgba(200, 200, 200, 0.6);
 }
 .img  {
   flex-basis: 50px;
 }
 .knight{
   
 }
 .note{
   color: rgba(200, 200, 200, 0.6);
   margin-bottom: 10px;
   margin-top: 10px;
 }
.loading {
  z-index: 999;
  background: rgb(37, 67, 109);
  color: white;
  font-size: 18px;
  display: flex;
  pointer-events: none;
  opacity: 0;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  width: 100%;
  position: absolute;
  transition: opacity ease-in-out 0.2s;
}
.loading.show {
  opacity: 1;
  transision: opacity ease-in-out 0.2s;
}
</style>
